(() => {
  'use strict';
  const setup = drawer => {
    if (drawer.dataset.drawerReady || typeof drawer.showModal !== 'function') return;
    drawer.dataset.drawerReady = 'true';
    const events = new AbortController();
    const container = drawer.querySelector('[data-drawer-container]');
    const status = drawer.querySelector('[data-drawer-status]');
    let busy = false, opener = null;
    const lock = value => {
      busy = value;
      container.querySelectorAll('button').forEach(button => {
        if (value) { button.dataset.beforeBusy = String(button.disabled); button.disabled = true; }
        else if (button.dataset.beforeBusy !== undefined) { button.disabled = button.dataset.beforeBusy === 'true'; delete button.dataset.beforeBusy; }
      });
    };
    const refresh = async () => {
      const url = new URL(drawer.dataset.cartUrl, location.origin);
      url.searchParams.set('section_id', 'crftop-cart-drawer-data');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to load your bag.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-cft-drawer-content]');
      if (!next) throw new Error('Unable to load your bag.');
      container.replaceChildren(next);
    };
    const open = async source => {
      if (drawer.open || busy) return;
      opener = source;
      drawer.showModal();
      lock(true); status.textContent = 'Loading your bag…';
      try { await refresh(); status.textContent = ''; }
      catch (_) { container.replaceChildren(); status.textContent = 'Unable to load your bag. Use View full bag to continue.'; }
      finally { lock(false); }
    };
    document.addEventListener('click', event => {
      const target = event.target.closest('[data-cft-cart-open]');
      if (!target || !drawer.closest('header')?.contains(target) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); open(target);
    }, { signal: events.signal });
    drawer.addEventListener('click', async event => {
      if (event.target === drawer || event.target.closest('[data-drawer-close]')) { drawer.close(); return; }
      const button = event.target.closest('[data-drawer-minus], [data-drawer-plus], [data-drawer-remove]');
      if (!button || busy) return;
      const row = button.closest('[data-drawer-line]');
      const current = Number(row.dataset.quantity), min = Number(row.dataset.min), step = Number(row.dataset.step);
      const max = row.dataset.max ? Number(row.dataset.max) : Infinity;
      const amount = button.hasAttribute('data-drawer-remove') ? 0 : current + (button.hasAttribute('data-drawer-plus') ? step : -step);
      if (!Number.isInteger(amount) || (amount !== 0 && (amount < min || amount > max || (amount - min) % step !== 0))) return;
      lock(true); status.textContent = 'Updating your bag…';
      let failed = false;
      try {
        const response = await fetch(`${drawer.dataset.changeUrl}.js`, { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: row.dataset.key, quantity: amount }) });
        if (!response.ok) failed = true;
      } catch (_) { failed = true; }
      try {
        await refresh();
        status.textContent = failed ? 'We could not confirm the update. Please review your bag.' : '';
      } catch (_) {
        container.replaceChildren();
        status.textContent = 'We could not confirm your bag. Use View full bag to check it.';
      } finally { lock(false); }
    });
    drawer.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
    drawer._cftDispose = () => { events.abort(); delete drawer.dataset.drawerReady; };
  };
  const scan = root => root.querySelectorAll('[data-cft-cart-drawer]').forEach(setup);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-cft-cart-drawer]').forEach(drawer => drawer._cftDispose?.()));
})();
